import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

type RollupEmptyStateProps = {
  children: ReactNode
}

export default function RollupEmptyState({ children }: RollupEmptyStateProps) {
  return (
    <Box
      sx={{
        border: (theme) => `dashed 1px ${theme.palette.divider}`,
        borderRadius: 2,
        p: 4,
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {children}
      </Typography>
    </Box>
  )
}
